module.exports = __webpack_public_path__ + "img/product-shot_02_loading.a8508949.jpg";